'use strict';

angular.module('app')
  .controller('AccountCtrl', function ($scope, $rootScope, $q, typeURL, info, Account, diviacLocalStorage, gettextCatalog, Profile) {
    var vm = this;

    vm.current = typeURL;

    vm.info = info;
    vm.personal = {};


    vm.account = Account;
    vm.profile = Profile;
    vm.user = diviacLocalStorage.get('user');


    if (vm.current === 'profile') {
      vm.loader = true;
      Profile.getPersonalInfo().then(function (data) {
        vm.personal = data;
      });

      $q.all([
        Profile.getContactInfo(),
        Profile.getPhone(),
      ])
        .then(function (data) {
          vm.address = data[0];
          vm.phone = data[1];

          vm.loader = false;
        });
    }

    Account.getPreferences().then(function (data) {
      vm.preferences = data;

      if (!vm.preferences.currency) {
        vm.preferences.currency = 'USD';
      }
    });


    vm.changePassword = function (data) {
      if ($scope.changePassword.$invalid) {
        vm.changePassSubmited = true;

        return true;
      }

      vm.changePassSubmited = false;
      vm.changeErrors = false;

      return vm.account.changePassword(data).then(function () {
        $rootScope.showNotify(gettextCatalog.getString('Your password was successfully changed'));
        vm.settings = {};
      }, function (error) {
        vm.changeErrors = error;
      });
    };

    vm.changeEmail = function (data) {
      if ($scope.changeEmail.$invalid) {
        vm.changeEmailSubmited = true;
        return true;
      }

      vm.changeEmailSubmited = false;
      vm.changeEmailErrors = false;

      return vm.account.changeEmail(data).then(function (email) {
        $rootScope.showNotify(gettextCatalog.getString('Your email was successfully changed'));
        vm.user.email = email;
      }, function (error) {
        vm.changeEmailErrors = error;
      });
    };
  });
